import type { CSSProperties, ReactNode } from 'react';
import { cn } from './cn';
import { fileUrl } from '../api/client';

export interface AvatarProps {
  src?: string | null;
  /** Diameter in px. */
  size?: number;
  /** Shown when there is no `src` (icon or initials). */
  fallback?: ReactNode;
  className?: string;
  style?: CSSProperties;
}

/** Circular avatar with image + fallback (replaces antd Avatar). */
export function Avatar({ src, size = 32, fallback, className, style }: AvatarProps) {
  return (
    <span
      className={cn(
        'inline-grid shrink-0 place-items-center overflow-hidden rounded-pill',
        'bg-surface-3 text-muted',
        className,
      )}
      style={{ width: size, height: size, ...style }}
    >
      {src ? <img src={fileUrl(src)} alt="" className="h-full w-full object-cover" /> : fallback}
    </span>
  );
}
